module.exports = {
    general_error: "Unerwarteter Fehler",
    hierarchy_duplicites: "Objekt existiert bereits",
    api_communication_error: "Fehler bei der Kommunikation mit dem Server",
    data_not_found: "Keine gespeicherten Daten gefunden",
    appliances_imprints_not_found: "Es sind keine Fingerabdrücke des Geräts vorhanden",
    success_removed_imprint: "Der Fingerabdruck der Appliance wurde erfolgreich entfernt",
    success_removed_all_imprints: "Alle Appliances wurden erfolgreich entfernt",
    energy_not_found_for_selected_time: "Keine gespeicherte Energie für ausgewählte Zeit",
    password_successfully_changed: "Passwort erfolgreich geändert",
    passwords_equal: "Passwörter müssen unterschiedlich sein",
    any_assigned_devices: "Keine zugeordneten Geräte",
    object_not_empty: "Objekt ist nicht leer",
    appliance_imprint_save_success: "Geräteabdruck erfolgreich gespeichert",
    error: "Error",
    success_removed_device: "Gerät erfolgreich entfernt",
    success: "Erfolg",
    success_removed_appliance: "Die Appliance wurde erfolgreich entfernt",
    many_edges: "Mehr als 2 Kanten erkannt",
    small_edges: "Weniger als 2 Kanten erkannt",
    any_edge: "Keine Kante erkannt",
    duplicate_appliance: "Appliance mit demselben Namen ist bereits vorhanden",
    delete_energy_succes: "Energie erfolgreich gelöscht",
    device_not_responding_or_offline: "Gerät reagiert nicht oder ist offline",
    lora_settings_successfully_set: "LoRa-Einstellungen erfolgreich festgelegt",
    success_removed_test_case: "Testfall erfolgreich entfernt",
    success_removed_test_profile: "Testprofil erfolgreich entfernt",
    login_credentials_incorrect: "Anmeldeinformationen falsch",
    if_want_testing_go_to_section_tesing: "Für dieses Gerät wurden keine Testergebnisse gespeichert. Wenn Sie dieses Gerät testen möchten, lesen Sie den Abschnitt Testen",
    before_start_testing: "Bevor Sie mit dem Test beginnen, schließen Sie das Testgerät an den Generator an.",
    before_start_another_testing: "Bevor Sie einen anderen Testvorgang starten, schließen Sie das Testgerät an den Generator an",
    copy_token_to_clipboard: "Token in Zwischenablage kopieren",
    token_copied: "Token kopiert",
    no_tokens_available: "Keine Token verfügbar",
    settings_successfully_saved: "Einstellungen erfolgreich gespeichert",
    choose_disconnector_menu: "Wählen Sie im Menü die Option disconnector oder Gruppe",
    current_firmware_version: "Aktuelle Firmware-Version",
    available_firmware_version: "Verfügbare Firmware-Version",
    starting_upgrade: "Upgrade starten...",
    upgrading: "Upgrade durchführen...",
    rebooting: "Neustart...",
    upgrade_failed: "Upgrade failed",
    upgrade_timeout: "Upgrade-Timeout. GERÄT NICHT STABIL!",
    upgrade_not_available: "Für dieses Gerät ist kein Firmware-Upgrade verfügbar",
    select_image_and_upload_map: "Bild auswählen und Karte hochladen",
    file_format_not_supported: "Dateiformat nicht unterstützt",
    file_too_large: "Die Datei ist zu groß, die maximal zulässige Größe beträgt 1 MB",
    image_file_upload_failed: "Das Hochladen der Bilddatei ist fehlgeschlagen",
    loading_image_failed: "Das Laden des Bildes ist fehlgeschlagen",
    please_wait: "Warten Sie mal...",
    success_saved_control_map: "Kontrollkarte erfolgreich gespeichert",
    device_status_change: "Gerät geht",
    turn_on_relay: "Anschalten",
    turn_off_relay: "Schalte aus",
    notify_anomaly_S_T: "Zeitdaueranomalie zwischen Ein- und Ausschalten des Geräts",
    notify_anomaly_S_D: "Anomalie der Laufzeitdauer",
    notify_anomaly_L_D: "Anomalie auf Tagesebene",
    notify_anomaly_L_W: "Anomalie auf Wochenebene",
    notify_anomaly_L_M: "Anomalie auf Monatsebene",
    notify_anomaly_L_Y: "Anomalie auf Jahresebene",
    oauth_cookies_disabled: "Cookies sind in der aktuellen Umgebung nicht aktiviert. Google-Anmeldeformular nicht erlaubt",
    ws_online: "Du bist online",
    ws_offline: "Du bist gerade offline"
  }